var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.5V1.5C15 0.671562 14.2801 0 13.3929 0L3.21429 0C1.43906 0 0 1.34312 0 3L0 13C0 14.6569 1.43906 16 3.21429 16H13.9286C14.5202 16 15 15.5522 15 15.0281C15 14.6619 14.7788 14.3556 14.4643 14.1812V11.6388C14.7924 11.3375 15 10.9438 15 10.5ZM12.8571 14H3.21429C2.62266 14 2.14286 13.5522 2.14286 13C2.14286 12.4478 2.62266 12 3.21429 12H12.8571V14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.d870ee1b58ee986190278a9908b89fac.svg";
export { ForwardRef as ReactComponent };